module.exports = __webpack_public_path__ + "img/asset2.c086faa0.png";